import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { NuevoClienteDocumentacionModal } from "app/features/componentes/nuevoclientedocumentacion/modal";
import { DireccionClienteSelectorView } from "./direccionView";
import { AgregarClienteButton } from "./agregarcliente";
import { Contacto } from "app/features/selectores/items/contacto";

interface Props {
    value?: number | null;
    onChange: (x: number | undefined) => void;
    /**Si es undefined no se muestra el selector de contacto */
    onChangeContacto?: (telefono: string | undefined, contactoDestino: number) => void;
    iconClass?: string;
    label?: string;
    error?: kea.FieldError;
    idCliente?: number;
    filtroCliente?: models.FiltroCliente;
    filtrarDireccionesPermiso?: boolean;
    idSucursalUsuario?: number;
    seleccionAutomatica?: boolean;
    contactoDestino: number;
    /**Si se define se va a filtrar sólo esta dirección */
    idDireccionUsuario?: number;
    readonly?: boolean;
}

interface State {
    idDireccion?: number;
}

const addDocumentacion = resources.Cliente.AddDocumentacion;
export class DireccionClienteSelector extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = { idDireccion: this.props.contactoDestino };
    }
    modalManager = kea.createModalManager();

    handleOnNuevoCliente = async () => {
        const result = await this.modalManager.showModal(NuevoClienteDocumentacionModal, { contactoObligatorio: true }, {
            Direccion: {},
            AceptaFletePorCobrar: true,
            ImprimirPrecioGuia: true,
            SeguroViaje: true,
            NumeroPoliza: "",
            Identificacion: {}
        } as models.NuevoClienteDocumentacion);
        if (result.result) {
            const nuevo = await addDocumentacion(result.value);
            this.props.onChange(nuevo.IdDireccionCliente);
        }
    }


    private handleOnContacto = async (x: any) => {
        var respond = await resources.Cliente.ConsultarContactosClientePorIdRegistro(x);
        this.setState({ idDireccion: respond.IdRegistro });
        if (this.props.onChangeContacto)
            this.props.onChangeContacto(respond.Telefono, respond.IdRegistro);
    }

    render() {
        return (
            <kea.Panel title={this.props.label} iconClass={this.props.iconClass} buttons={!this.props.readonly && <kea.AgregarButton onClick={this.handleOnNuevoCliente} />} error={this.props.error} >
                <DireccionClienteSelectorView {... this.props} />
                {
                    this.props.onChangeContacto &&
                    <Contacto
                        readonly={this.props.readonly}
                        value={this.state.idDireccion}
                        onChange={this.handleOnContacto}
                        idDireccion={this.props.value}
                        label="Contacto"
                    />
                }
                {this.modalManager.component}
            </kea.Panel>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/selectores/items/direccioncliente/direccion.tsx